<template>
  <section class="content_section">
    <SimpleList v-if="this.isLoaded"
                :serverside="false"
                @filter="getFiltered"
                :suppliersSource="'getAllSuppliers'"
                :wide="100"
                :data="suppliers"
                :options="options"
                :title=options.Lang.Aktive_Suppliers
                :defaultCount=defaultCount
                :cols="cols"
                :hideCols="hideCols"
                :emptyState="options.Lang.Keine_Suppliers_vorhanden"
                :buttonText=options.Lang.Neuen_Supplier_anlegen
                buttonAction="Suppliers"
                :actions="actions"
                :clean="false"
                @updateData="getAll()"></SimpleList>
    <FormSupplier @updateData="getAll()" v-if="options.showSuppliersForm && options.user.loggedIn"
                :currentSupplier="options.currentSupplier" :options="options"></FormSupplier>
    <FormImportTrip @updateData="getAll()" v-if="options.showImportTripForm && options.user.loggedIn"
                    :currentTrip="options.currentTrip" :options="options"></FormImportTrip>
    <FormUser @updateData="getAll()" v-if="options.showUserForm && options.user.loggedIn"
              :currentFormUser="options.currentFormUser" :options="options"></FormUser>
  </section>
</template>
<script>

import SimpleList from "@/components/lists/SimpleList";
import FormUser from "@/components/dialogs/FormUser";
import FormSupplier from "@/components/dialogs/FormSupplier";
import FormImportTrip from "@/components/dialogs/FormImportTrip";

const toLower = text => {
  if (text !== null) {
    return text.toString().toLowerCase()
  } else {
    return "";
  }
}

export default {
  name: 'suppliers',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    SimpleList,
    FormSupplier,
    FormUser,
    FormImportTrip
  },
  data() {
    return {
      defaultCount: null,
      search: null,
      searchedUsers: [],
      selectedSuppliers: [],
      suppliers: [],
      hideCols: ['id', 'gender'],
      cols: ['id', 'supplier_name', 'gender', 'firstname', 'lastname', 'email'],
      isLoaded: false,
      actions: [
        {
          icon: 'edit_note',
          action: 'editSupplier',
          title: this.options.Lang.Supplier_bearbeiten
        },
        {
          icon: 'icon-archive_FILL0_wght400_GRAD0_opsz48',
          action: 'archivSupplier',
          title: this.options.Lang.Supplier_archivieren
        },
      ],
    };
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  mounted(){
    this.defaultCount = this.options.defaultCount;
    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
   
  },
  created() {
    this.options.isUploading = true;
    this.getAll();
  },
  methods: {
    getAll() {
      let self = this;
      self.isLoaded = false;
      self.options.isUploading = true;
      //console.log('test');
      this.doPost({userdata: self.options.user}, 'getAllSuppliers', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.suppliers = values;
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },
    getFiltered(args) {
      //console.log(args);
      let self = this;
      self.options.isUploading = true;
      let where = args && args.where ? args.where : null;
      let order = args && args.order ? args.order : null;
      this.doPost({
        userdata: self.options.user,
        data: {
          where: where,
          sort: order
        }
      }, 'getAllSuppliers', function (res) {
        //console.log(res);
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.suppliers = values;
            //console.log(self.clients);
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },
  }
};
</script>